<template>
  <div>
    <server-error :error="error" />
    <div data-cy="registry-contract-page">
      <div class="px-6 pt-4 pb-10">
        <div class="container">
          <h1 class="mb-4">
            {{ $t('CONTENT.settingsPage.settings') }}
          </h1>
          <OwnerSettings :is-read-only-mode="isReadOnlyMode"/>
          <CounterpartyGroupSettings
            :counterparty-group="systemSettingsGroup"
            :is-read-only-mode="isReadOnlyMode"
          />
          <ContractSettings :is-read-only-mode="isReadOnlyMode"/>
          <ClosedPeriodSettings :is-read-only-mode="isReadOnlyMode"/>
          <div v-if="!isReadOnlyMode">
            <Logs/>
            <PaymentSettings/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContractSettings from '../components/settings/ContractSettings';
import OwnerSettings from '../components/settings/OwnerSettings';
import CounterpartyGroupSettings from '../components/settings/CounterpartyGroupSettings';
import ClosedPeriodSettings from '../components/settings/ClosedPeriodSettings';
import Logs from '../components/settings/Logs';
import PaymentSettings from '../components/settings/PaymentSettings';

export default {
  components: {
    ContractSettings,
    OwnerSettings,
    CounterpartyGroupSettings,
    PaymentSettings,
    Logs,
    ClosedPeriodSettings,
  },
  data() {
    return {
      systemSettingsGroup: [],
      role: null,
      error: null,
      isReadOnlyMode: true,
    };
  },
  created() {
    this.role = localStorage.getItem('role');
    if (this.role === 'Admin') {
      this.isReadOnlyMode = false;
    }
  },
  async beforeCreate() {
    try {
      this.error = null;
      this.$loadingManager.addLoadingStep(1);
      const [,,, settings,counterpartyGroup,] = await Promise.all([
        this.$store.dispatch('getAllCounterpartyTypes'),
        this.$store.dispatch('loadAllCurrencyCode'),
        this.$store.dispatch('getAllCounterparties'),
        this.$store.dispatch('loadContractSettings'),
        this.$store.dispatch('loadCounterpartyGroup'),
        this.$store.dispatch('getAllCounterpartyAddressTypes'),
        this.$store.dispatch('getAllDirectoryLegalForms'),
      ]);
      const alternative = [{
        counterpartyId: null,
        isIntragroupTurnover: false,
      }];
      this.systemSettingsGroup = this.setDefaultCounterpatyGroup(counterpartyGroup, alternative);
      this.$loadingManager.loadingStepLoaded();
    } catch (e) {
      this.$loadingManager.hideLoadScreen();
      this.error = e;
    }
  },
  methods: {
    setDefaultCounterpatyGroup(data, alt) {
      return data.length === 0 ? alt : data;
    },
  },
};
</script>
